<div class="relative overflow-x-auto shadow-md sm:rounded-lg">
    <div class="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between pb-4">
        <!-- Dropdown menu -->
        <label for="table-search" class="sr-only">Search</label>
        <div class="relative">
            <div class="absolute inset-y-0 left-0 rtl:inset-r-0 rtl:right-0 flex items-center ps-3 pointer-events-none">
                <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor"
                    viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clip-rule="evenodd"></path>
                </svg>
            </div>
            <input type="text" id="table-search" [(ngModel)]="view.filterText" 
                class="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Search by title or description">
        </div>
        
    </div>
    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" class="px-6 py-3">
                    Code
                </th>
                <th scope="col" class="px-6 py-3">
                    Name
                </th>
                <th scope="col" class="flex justify-center items-center text-center px-6 py-3 ">
                    Profile ID
                </th>
                <!-- <th scope="col" class="px-6 py-3">
                    SiteID
                </th> -->
                <!-- <th scope="col" class="px-6 py-3">
                    siteGUID
                </th> -->
                <th scope="col" class="px-6 py-3">
                    Website
                </th>
                <th scope="col" class="px-6 py-3">
                    Created
                </th>
                <th scope="col" class="px-6 py-3">
                    Status
                </th>
                <th scope="col" class="px-6 py-3">
                    Channels
                </th>
                <th scope="col" class="px-6 py-3">
                    Actions
                </th>
            </tr>
        </thead>
        
        <tbody *ngFor="let agency of this.view.agenciesFiltered | filter:view.filterText">
            <tr *ngFor="let channel of agency.sites" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    {{channel.code}}
                </th>
                <td class="px-6 py-4">
                        {{channel.name}}
                        <sup>{{channel.agencyID}}</sup>
                </td>
                <td class="flex justify-center items-center px-6 py-4">
                        {{channel.profileID}}
                </td>
                <!-- <td class="px-6 py-4">
                        {{channel.id}}
                </td> -->
                <!-- <td class="px-6 py-4">
                        {{channel.guid}}
                </td> -->
                <td class="px-6 py-4">
                        {{channel.website}}
                </td>
                <td class="px-6 py-4">
                        {{channel.createdOn  | date:'yyyy-MM-dd' }}
                </td>
                <td class="px-6 py-4">
                    <mat-slide-toggle
                        [checked]="channel.isActive"
                        (change)="onToggle(channel)"
                        color="primary"
                    >
                    </mat-slide-toggle>
                </td>

                <td class="px-6 py-4">
                        <!-- <button class="bg-primary-500 hover:bg-primary-700 text-white  py-2 px-4 rounded-full" (click)="navigateToClient(channel.agencyID, channel.code.toLowerCase())">Open</button> -->
                        <!-- <button class="bg-primary-500 hover:bg-primary-700 text-white  py-2 px-4 rounded-full" (click)="navigateToClient(channel)">Open</button> -->

                        <a class="bg-primary-500 hover:bg-primary-700 text-white  py-2 px-4 rounded-full" [routerLink]="['/']" [queryParams]="{ ai: channel.agencyID, sc: channel.code }" target="_blank">Open</a>
                </td>
                <!-- Action Menu Column -->
                <td class="px-6 py-4 text-right">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="onView(channel)">
                            <mat-icon>visibility</mat-icon>
                            <span>View</span>
                        </button>
                        <!-- <button mat-menu-item (click)="onEdit(channel)">
                            <mat-icon>edit</mat-icon>
                            <span>Edit</span>
                        </button> -->
                        <button mat-menu-item (click)="onDelete(channel)">
                            <mat-icon>delete</mat-icon>
                            <span>Delete</span>
                        </button>
                    </mat-menu>
                </td>
                </tr>
            
        </tbody>
    </table>
</div>

<nav aria-label="Page navigation example">
    <ul class="flex items-center -space-x-px h-10 text-base mt-5 justify-center">
        <li>
            <a href="#"
                class="flex items-center justify-center px-4 h-10 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                <span class="sr-only">Previous</span>
                <svg class="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 6 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M5 1 1 5l4 4" />
                </svg>
            </a>
        </li>
        <li>
            <a href="#"
                class="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">1</a>
        </li>
        <li>
            <a href="#"
                class="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">2</a>
        </li>
        <li>
            <a href="#" aria-current="page"
                class="z-10 flex items-center justify-center px-4 h-10 leading-tight text-blue-600 border border-blue-300 bg-blue-50 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white">3</a>
        </li>
        <li>
            <a href="#"
                class="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">4</a>
        </li>
        <li>
            <a href="#"
                class="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">5</a>
        </li>
        <li>
            <a href="#"
                class="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                <span class="sr-only">Next</span>
                <svg class="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 6 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 9 4-4-4-4" />
                </svg>
            </a>
        </li>
    </ul>
</nav>